
import ProductCardTemplate from '~/components/widgets/AddToCardBtn/ProductCardTemplate';
import ProductPageTemplate from '~/components/widgets/AddToCardBtn/ProductPageTemplate';

export default {
  name: 'AddToCartBtn',

  data() {
    return {
      productPageCount: 1,
    };
  },
  components: { ProductPageTemplate, ProductCardTemplate },

  props: {
    productId: {
      type: Number,
      default: null,
    },

    // пропс для темплейта со страницы товара
    isProductPageTemplate: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isAddToCart() {
      const cartItems = this.$store.state?.cart?.items || [];
      const { productId } = this;

      return Boolean(cartItems.find((t) => t?.product?.id === productId));
    },

    countAddedToCart() {
      const cartItems = this.$store.state?.cart?.items || [];
      const { productId } = this;
      const productFromCart = cartItems.find((t) => t?.product?.id === productId);

      return productFromCart?.quantity || 0;
    },
  },

  methods: {

    // Логика добавления / изменения кол-во товара в корзине
    async addProductToCard(props = {}) {
      const { isChangeQuantity, isClear } = props;

      if (isClear) {
        await this.removeProductCount();
        return;
      }

      const productItemCart = {
        productId: this.productId,
        quantity: isChangeQuantity ? this.productPageCount : 1,
      };

      await this.$store.dispatch('cart/putToCart', productItemCart);
      await this.$store.dispatch('cart/getCart');
    },

    async changeProductCount(newCount) {
      if (newCount <= 0) {
        await this.removeProductCount();
        return;
      }

      const cartItems = this.$store.state?.cart?.items || [];
      const { productId } = this;
      const productFromCart = cartItems.find((t) => t?.product?.id === productId);

      const cartItemParams = {
        cartItemId: productFromCart.id,
        quantity: newCount,
      };
      await this.$store.dispatch('cart/updateCartItem', cartItemParams);
      await this.$store.dispatch('cart/getCart');
    },

    async removeProductCount() {
      const cartItems = this.$store.state?.cart?.items || [];
      const { productId } = this;
      const productFromCart = cartItems.find((t) => t?.product?.id === productId);

      await this.$store.dispatch('cart/removeCartItem', String(productFromCart.id));
      await this.$store.dispatch('cart/getCart');
    },
  },

  mounted() {
    if (this.countAddedToCart) {
      this.productPageCount = this.countAddedToCart;
    }
  },
};

